// import React, { useState } from 'react';
// import axios from 'axios';
// import logo from '../img/logo.png';

// const UserDelete = () => {
//   const [membershipNo, setMembershipNo] = useState('');
//   const [userData, setUserData] = useState(null);
//   const [otp, setOtp] = useState('');
//   const [showOtpField, setShowOtpField] = useState(false);
//   const [generatedOtp, setGeneratedOtp] = useState(null);

//   const fetchUserData = async () => {
//     try {
//       const response = await axios.get(`http://localhost:8007/auth/api//api/user?membershipNo=${membershipNo}`);
//       setUserData(response.data);
//     } catch (error) {
//       console.error('Error fetching user data', error);
//       alert('User not found!');
//     }
//   };

//   const sendOtp = async () => {
//     try {
//       const response = await axios.post('http://localhost:8007/auth/api//api/send-otp', { email: userData.emailId });
//       setGeneratedOtp(response.data.otp);
//       setShowOtpField(true);
//       alert('OTP sent to email!');
//     } catch (error) {
//       console.error('Error sending OTP', error);
//     }
//   };

//   const verifyAndDeleteUser = async () => {
//     if (otp !== generatedOtp) {
//       alert('Invalid OTP');
//       return;
//     }
//     try {
//       await axios.post('http://localhost:8007/auth/api//api/delete-user', { membershipNo });
//       alert('User deleted successfully');
//       setUserData(null);
//       setShowOtpField(false);
//       setOtp('');
//     } catch (error) {
//       console.error('Error deleting user', error);
//     }
//   };

//   return (
//     <div className="container mx-auto p-4">
//       <nav className="d-flex align-items-center justify-between bg-blue-500 p-4">
//         <img src={logo} alt="Logo" className="h-10" />
//         <h1 className="text-white text-xl font-bold">Welcome 320B App</h1>
//       </nav>

//       <div className="mt-6">
//         <input
//           type="text"
//           placeholder="Enter Membership No"
//           value={membershipNo}
//           onChange={(e) => setMembershipNo(e.target.value)}
//           className="border p-2 rounded mr-2"
//         />
//         <button onClick={fetchUserData} className="bg-blue-500 text-white px-4 py-2 rounded">Search</button>
//       </div>

//       {userData && (
//         <div className="mt-4 p-4 border rounded shadow">
//           <p><strong>Name:</strong> {userData.membershipName}</p>
//           <p><strong>Email:</strong> {userData.emailId}</p>
//           <p><strong>Mobile:</strong> {userData.mobile}</p>
//           <p><strong>Club:</strong> {userData.clubName}</p>
//           <button onClick={sendOtp} className="bg-red-500 text-white px-4 py-2 rounded mt-2">Delete User</button>
//         </div>
//       )}

//       {showOtpField && (
//         <div className="mt-4">
//           <input
//             type="text"
//             placeholder="Enter OTP"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value)}
//             className="border p-2 rounded mr-2"
//           />
//           <button onClick={verifyAndDeleteUser} className="bg-green-500 text-white px-4 py-2 rounded">Verify & Delete</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserDelete;

import React, { useState } from 'react';
import axios from 'axios';
import Llogo from '../img/Llogo.png';
import { FiUser, FiMail, FiPhone, FiUsers, FiTrash2 } from "react-icons/fi"; 
import { colors } from '@mui/material';

const UserDelete = () => {
  const [membershipNo, setMembershipNo] = useState('');
  const [userData, setUserData] = useState(null);
  const [otp, setOtp] = useState('');
  const [showOtpField, setShowOtpField] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState(null);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://lionsdirectoryapi.emedha.in/auth/api/api/user?membershipNo=${membershipNo}`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user data', error);
      alert('User not found!');
    }
  };

  const sendOtp = async () => {
    try {
      const response = await axios.post('https://lionsdirectoryapi.emedha.in/auth/api/api/send-otp', { email: userData.emailId });
      setGeneratedOtp(response.data.otp);
      setShowOtpField(true);
      alert('OTP sent to email!');
    } catch (error) {
      console.error('Error sending OTP', error);
    }
  };

  const verifyAndDeleteUser = async () => {
    if (otp !== generatedOtp) {
      alert('Invalid OTP');
      return;
    }
    try {
      await axios.post('https://lionsdirectoryapi.emedha.in/auth/api/api/delete-user', { membershipNo });
      alert('User deleted successfully');
      setUserData(null);
      setShowOtpField(false);
      setOtp('');
    } catch (error) {
      console.error('Error deleting user', error);
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <img src={Llogo} alt="Logo" style={styles.logo} />
        <h1 style={styles.title}>Welcome to Lions Directory</h1>
      </header>

      {/* Main Content */}
      <div style={styles.content}>
        {/* Search Field */}
        <div style={styles.searchContainer}>
          <input
            type="text"
            placeholder="Enter Membership No"
            value={membershipNo}
            onChange={(e) => setMembershipNo(e.target.value)}
            style={styles.input}
          />
          <button onClick={fetchUserData} style={styles.buttonPrimary}>Search</button>
        </div>

       {/* User Details */}
{userData && (
  <div style={styles.userCard}>

    <div style={styles.userInfo}>
      <p><FiUser style={styles.icon} /><strong>Name:</strong> {userData.membershipName}</p>
      <p><FiMail style={styles.icon} /><strong>Email:</strong> {userData.emailId}</p>
      <p><FiPhone style={styles.icon} /><strong>Mobile:</strong> {userData.mobile}</p>
      <p><FiUsers style={styles.icon} /><strong>Club:</strong> {userData.clubs}</p>
    </div>
    
    <button onClick={sendOtp} style={styles.buttonDanger}>
      <FiTrash2 style={styles.iconButton} /> Delete User
    </button>
  </div>
)}

        {/* OTP Verification */}
        {showOtpField && (
          <div style={styles.otpContainer}>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              style={styles.input}
            />
            <button onClick={verifyAndDeleteUser} style={styles.buttonSuccess}>Verify & Delete</button>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <p>@2025 Emedha Technologies. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

/* Styling */
const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f4f4f4',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  header: {
    width: '100%',
    backgroundColor: '#002366', // Navy Blue
    color: '#FFD700', // Gold
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
  logo: {
    height: '60px',
  },
  title: {
    fontSize: '22px',
    fontWeight: 'bold',
    textAlign: 'center',
    flex: 1,
  
  },
  content: {
    width: '100%',
    maxWidth: '600px',
    margin: '20px auto',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
  },
  input: {
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    width: '70%',
  },
  buttonPrimary: {
    backgroundColor: '#002366',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  buttonDanger: {
    backgroundColor: '#DC143C',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px',
    fontWeight: 'bold',
  },
  buttonDanger: {
    backgroundColor: '#DC143C',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px',
    fontWeight: 'bold',
  },
  buttonSuccess: {
    backgroundColor: '#DC143C',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  userCard: {
    marginTop: '20px',
    padding: '25px',
    borderRadius: '12px',
    background: 'linear-gradient(135deg, #002366, #001a44)', // Navy Blue Gradient
    color: '#ffffff', // Gold Text
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
   
  },
  cardTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '15px',
    borderBottom: '2px solid #FFD700',
    display: 'inline-block',
    paddingBottom: '5px',
  },
  userInfo: {
    fontSize: '18px',
    lineHeight: '1.8',
    display: 'flex',
    flexDirection: 'column',

  },
  icon: {
    marginRight: '8px',
    color: '#FFD700', // Gold color
    fontSize: '20px',
  },
  iconButton: {
    marginRight: '5px',
    fontSize: '18px',
  },
  buttonDanger: {
    backgroundColor: '#dc3545',
    color: 'white',
    padding: '12px 25px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'background 0.3s ease, transform 0.2s',
    marginTop: '20px',
    boxShadow: '0px 4px 10px rgba(255, 0, 0, 0.3)',
  },
  buttonDangerHover: {
    backgroundColor: '#b22222',
    transform: 'scale(1.05)',
  },
  otpContainer: {
    marginTop: '20px',
    textAlign: 'center',
  },
  footer: {
    width: '100%',
    backgroundColor: '#002366',
    color: '#FFD700',
    padding: '15px',
    textAlign: 'center',
    fontWeight: 'bold',
  },
};

export default UserDelete;
